import React, { useMemo } from 'react';
import {
  Box,
  CircularProgress,
  BottomNavigation,
  BottomNavigationAction,
  Paper,
} from '@mui/material';
import { useWarbandStore } from '../../stores/warbandStore';
import { PlayWizardsAndSpellsTab } from '../tabs/PlayWizardsAndSpellsTab';
import { PlaySoldiersTab } from '../tabs/PlaySoldiersTab';
import { IndexTab } from '../tabs/IndexTab';
import { SwipeTabs } from '../shared/SwipeTabs';
import { useSwipeTabs } from '../../hooks/useSwipeTabs';
import { useIceSurface } from '../../hooks/useIceSurface';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { createIceSurface } from '../../theme/surfaces';

export const PlayWarbandPage: React.FC = () => {
  const {
    isLoading,
    selectedWarbandId,
    playTabIndex,
    setPlayTabIndex,
    isMinified,
    currentPage,
  } = useWarbandStore();

  const { containerRef, trackRef } = useSwipeTabs(playTabIndex, 3, setPlayTabIndex, currentPage === 'play');

  // Stable reference so SwipeTabs (React.memo) skips re-rendering tabs on index changes.
  const panels = useMemo(() => [
    <PlaySoldiersTab key="soldiers" minified={isMinified} />,
    <PlayWizardsAndSpellsTab key="spells" />,
    <IndexTab key="index" />,
  ], [isMinified]);

  const tabsSurface = useIceSurface({ icicles: true, card: true });
  const iceSurface = createIceSurface(11);

  if (!selectedWarbandId) {
    return <Box>No party selected</Box>;
  }

  return (
    <Box sx={{ width: '100%', flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
      {isLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <SwipeTabs containerRef={containerRef} trackRef={trackRef} numTabs={3} panelPb={10}>
            {panels}
        </SwipeTabs>
      )}
      <Paper sx={{ ...iceSurface, position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1 }} elevation={3} >
        <BottomNavigation
          sx={{
            ...tabsSurface,
          }}
          showLabels
          value={playTabIndex}
          onChange={(event, newValue) => {
            setPlayTabIndex(newValue);
          }}
        >
          <BottomNavigationAction label="Party" icon={<AccessibilityIcon />} />
          <BottomNavigationAction label="Spells" icon={<AutoFixHighIcon />} />
          <BottomNavigationAction label="Index" icon={<MenuBookIcon />} />
        </BottomNavigation>
      </Paper>
    </Box>
  );
};
